import { VStack } from '@cbhq/cds-web/layout';

type SingleColumnLayoutProps = {
  children: React.ReactNode;
};

export function SingleColumnLayout({ children }: SingleColumnLayoutProps) {
  return (
    <VStack spacingVertical={10} alignItems="center">
      <VStack bordered borderRadius="roundedLarge">
        {children}
      </VStack>
    </VStack>
  );
}
